import React from 'react';
import hoverLogoBlack from '../../../../assets/img/icons/hover.black.png';
import hoverLogoLight from '../../../../assets/img/icons/hover.light.png';
import { useOneButtonStore } from '../../../../store/oneButtonStore';
import './oneButton-css/HoverLogoMark.css';

export type HoverLogoMarkProps = {
    /** Compact for buttons; `icon` crops to the house mark for square rail cells. */
    size?: 'sm' | 'md' | 'icon';
    className?: string;
    title?: string;
    /** `auto` follows app theme. `light` = white wordmark (blue/dark headers). */
    tone?: 'auto' | 'light' | 'black';
};

/** HOVER wordmark: `hover.black.png` on light theme, `hover.light.png` on dark. */
export const HoverLogoMark: React.FC<HoverLogoMarkProps> = ({
    size = 'md',
    className,
    title = 'HOVER',
    tone = 'auto',
}) => {
    const theme = useOneButtonStore((s) => s.theme);
    const src =
        tone === 'light'
            ? hoverLogoLight
            : tone === 'black'
              ? hoverLogoBlack
              : theme === 'dark'
                ? hoverLogoLight
                : hoverLogoBlack;

    return (
        <img
            src={src}
            alt="HOVER"
            title={title}
            className={`obd-hover-logo-mark obd-hover-logo-mark--${size}${className ? ` ${className}` : ''}`}
        />
    );
};

export default HoverLogoMark;
